import UserEvent from './models'

export default UserEvent
